import {
  useWSModalCustom,
  WSForm,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSSelect,
  WSText
} from "@wingspanhq/fe-component-library";
import { TransactionType } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import * as Yup from "yup";
import { TRANSACTION_TYPE_SELECT_OPTIONS } from "../utils/transactionTypeOptions";

type FormData = { type: TransactionType | "" };

type Props = { count: number } & WSModalCustomProps<TransactionType | null>;

const ModalBulkSetType: React.FC<Props> = props => (
  <WSForm<FormData>
    onSubmit={formData => props.onClose(formData.type ? formData.type : null)}
    defaultValues={{ type: "" }}
    validationSchema={Yup.object().shape({
      type: Yup.string().required("Required")
    })}
  >
    <WSModal
      title="Set type"
      size="S"
      onClose={() => props.onClose(null)}
      actions={{
        buttons: [
          {
            label: "Cancel",
            kind: "Secondary",
            type: "button",
            onClick: () => props.onClose(null)
          },
          { label: `Set ${props.count}` }
        ]
      }}
    >
      <WSList gap="M">
        <WSText color="gray500">
          Set the same type on the {props.count} selected transactions.
        </WSText>
        <WSForm.Field
          name="type"
          label="Type"
          component={WSSelect}
          componentProps={{ options: TRANSACTION_TYPE_SELECT_OPTIONS }}
        />
      </WSList>
    </WSModal>
  </WSForm>
);

export const useModalBulkSetType = () => useWSModalCustom(ModalBulkSetType);
